import React from 'react';
import Styles from './OutgoingMessage.module.scss';
import { Spinner } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { ArrowRotateRight, Back, CloseCircle } from 'iconsax-react';
import Message from './Message.js';
import MessageContent from './MessageContent.js';
import { CONTENT_TYPE, TICKET_STATUS } from '../../../const/ChatConst.js';
import dayjs from 'dayjs';
import { ThreeDots } from 'react-loader-spinner';
import { CheckOutlined } from '@ant-design/icons';

@observer
class OutgoingMessage extends React.Component {
  replyMessage(message) {
    let { store } = this.props;
    store.replyMessage = message;
  }

  render() {
    let { message, store } = this.props;
    let {
      createdAt,
      isSent = true,
      isSending = false,
      focus = false,
      notConfirmCount = 0,
      replyMessage,
      content,
      // isConfirm = false,
    } = message;
    const isCall = store.channel?.inflowType === 'IVR';
    const isConfirming = notConfirmCount > 0;
    const isActive = store.channel.status === TICKET_STATUS.ACTIVE;

    if (content.type === CONTENT_TYPE.TEXT && !content.value.trim()) return;
    return (
      <div
        className={`${Styles.Container} ${focus ? Styles.Focus : ''}`}
        onAnimationEnd={() => {
          store.messageMap.set(message.id, { ...message, focus: false });
        }}
      >
        <div className={Styles.Content}>
          <div className={Styles.ContentInner}>
            <div className={Styles.MessageOption}>
              {/* 
              답장버튼
              {!isSending && isSent && store.channel.status !== 'CLOSED' && (
                <Button
                  variant={'secondary'}
                  size={'sm'}
                  className={Styles.Button}
                >
                  <Back
                    className={Styles.Icon}
                    onClick={() => {
                      this.replyMessage(message);
                    }}
                  />
                </Button>
              )} 
               */}
              {isSending ? (
                <div className={Styles.Resending}>
                  <Spinner animation="border" variant="secondary" size="sm" />
                </div>
              ) : (
                !isSent && (
                  <div className={Styles.Resending}>
                    <Button
                      variant={'secondary'}
                      size={'sm'}
                      className={Styles.ResendButton}
                      onClick={() => {
                        store.openResendDialog(message);
                      }}
                    >
                      <ArrowRotateRight />
                      <CloseCircle color={`var(--bs-danger)`} />
                    </Button>
                  </div>
                )
              )}
              {!isSending && isCall && (
                <div className={Styles.TtsCheck}>
                  {isActive && isConfirming ? (
                    <ThreeDots
                      height="36"
                      width="24"
                      radius="9"
                      color="var(--qt-cool-gray7)"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    <CheckOutlined />
                  )}
                </div>
              )}
              {!isSending && !isCall && isConfirming && (
                <div className={Styles.NotConfirmCount}>{notConfirmCount}</div>
              )}
            </div>
            <Message isIncoming={false} store={store}>
              <MessageContent
                content={content}
                messageKey={message.id}
                store={store}
                isIncoming={false}
                replyMessage={replyMessage}
              />
            </Message>
          </div>
          <div className={Styles.Date}>{dayjs(createdAt).format('LT')}</div>
        </div>
      </div>
    );
  }
}

export default OutgoingMessage;
